export const BASKETS = '/baskets'